import { InjectionToken } from '@angular/core';

export const DEFI_API_BASE_URL = new InjectionToken<string>(
  'Defi API Base URL',
);

export const LOGOS_URL = new InjectionToken<string>('Logos URL');
